import classnames from 'classnames';

const getSelectionBoxStyles = ({ isSelected , isDisabled , className  } = {})=>classnames('selection-box', className, {
        _is_selected: isSelected && !isDisabled,
        _is_disabled: isDisabled
    })
;

export { getSelectionBoxStyles };
//# sourceMappingURL=get-selection-box-styles.js.map
